export const isWebPushSupported = (): boolean => {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
};
